import { render, staticRenderFns } from "./setInfo.vue?vue&type=template&id=71c1537f&scoped=true&lang=pug"
import script from "./setInfo.vue?vue&type=script&lang=js"
export * from "./setInfo.vue?vue&type=script&lang=js"
import style0 from "./setInfo.vue?vue&type=style&index=0&id=71c1537f&prod&lang=scss&scoped=true"
import style1 from "./setInfo.vue?vue&type=style&index=1&id=71c1537f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c1537f",
  null
  
)

export default component.exports